import api from 'api';
import LoaderSpinner from 'components/LoaderSpinner/LoaderSpinner';
import React, { useEffect, useState } from 'react';
import PlatformProviderSet from './components/PlatformProviderSet/PlaformProviderSet';
import {
  blankCharge,
  blankPPCharge,
  PlatformProviderChargeType
} from './types';
import './providerPlatformCharges.scss';
import { Button, Modal, BoxWrapper } from 'components/Base';
import DropdownInput from 'components/Dropdown/Dropdown';
import { connect } from 'react-redux';
import selectors from 'store/selectors';
import ChargeSet from './components/ChargeSet/ChargeSet';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolderOutlined';
import ReadOnlyAlert from 'components/Base/Alert/ReadOnlyAlert';
import Routes from 'consts/routes';
import { useHistory } from 'react-router-dom';

export const chargeTypes = {
  1: 'Tiered',
  2: 'Stepped',
  3: 'Fixed'
};

export const chargeValueTypes = {
  1: 'MONETARY',
  2: 'PERCENTAGE'
};

const ProviderPlatformChargesComponent = ({ isFirmAdmin }: any) => {
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [chargeData, setChargeData] = useState(
    {} as PlatformProviderChargeType
  );
  const [selectedPlatformType, setSelectedPlatformType] = useState(null);
  const [selectedProviderType, setSelectedProviderType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [charges, setCharges] = useState([] as PlatformProviderChargeType[][]);
  const [tempCharges, setTempCharges] = useState(
    [] as PlatformProviderChargeType[][]
  );
  const [platformTypes, setPlatformTypes] = useState([]);
  const [providerTypes, setProviderTypes] = useState([]);
  const [policyTypes, setPolicyTypes] = useState([]);
  const [applicationTypes, setApplicationTypes] = useState([]);

  const filteredCharges = (charges: any) => {
    return charges
      .reduce((acc: any, val: any) => {
        const key = val.policy_platform;
        if (acc[key]) acc[key].push(val);
        else acc[key] = [val];
        return acc;
      }, [])
      .sort((a: any, b: any) => a.id > b.id);
  };

  useEffect(() => {
    setIsLoading(true);
    Promise.all([
      api.providerPlatformChargesApi.getProviderPlatformCharges(),
      api.getMetaPolicyPlatform(),
      api.getMetaPolicyProvider(),
      api.getMetaPolicyType(),
      api.getMetaPlatformChargeApplicationTypes()
    ]).then(
      ([
        platformCharges,
        platforms,
        providers,
        policyTypes,
        applicationTypes
      ]) => {
        setCharges(Object.values(filteredCharges(platformCharges.data)));
        setTempCharges(platformCharges.data);
        setPlatformTypes(platforms.data);
        setProviderTypes(providers.data);
        setPolicyTypes(policyTypes.data);
        setApplicationTypes(applicationTypes.data);
        setIsLoading(false);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCharges(Object.values(filteredCharges(tempCharges)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tempCharges.length]);

  const updateChargeData = (chargeData: any) => {
    const indexToEdit = tempCharges.findIndex(
      (tempCharge: any) => tempCharge.id === chargeData.id
    );
    const updatedCharges = tempCharges.filter(
      (_, index) => index !== indexToEdit
    );
    setTempCharges(updatedCharges);
    setChargeData(chargeData);
  };

  const deleteChargeItem = (id: number) => {
    const indexToRemove = tempCharges.findIndex(
      (tempCharge: any) => tempCharge.id === id
    );
    const updatedCharges = tempCharges.filter(
      (_, index) => index !== indexToRemove
    );
    setTempCharges(updatedCharges);
  };

  const updateCharge = (index: number, chargeData: any) => {
    const chargeExists = tempCharges.find(
      (charge: any) => charge.id === chargeData.id
    );

    if (!chargeExists) {
      tempCharges.push(chargeData);
      setTempCharges(tempCharges);
    }

    setIsModalOpen(false);
  };

  const getPlatformType = (platform: any) => {
    return platformTypes.find(
      (pt: any) => Number(pt.value) === platform
    ) as any;
  };

  const getProviderTypes = (provider: any) => {
    return providerTypes.find(
      (pt: any) => Number(pt.value) === provider
    ) as any;
  };

  const addCharge = (platform?: any) => {
    setSelectedPlatformType(getPlatformType(platform));
    setIsModalOpen(true);

    if (!platform) {
      setChargeData(blankPPCharge());
      return;
    }

    setChargeData(blankCharge(platform));
  };

  const addChargeSet = (index: number, platform: number) => {
    addCharge(platform);
  };

  const editCharge = (charge: any) => {
    setSelectedPlatformType(getPlatformType(charge.policy_platform));
    setSelectedProviderType(getProviderTypes(charge.policy_provider));
    setIsModalOpen(true);
    setChargeData(charge);
  };

  return (
    <>
      <div>
        {!isLoading && !isFirmAdmin && charges.length > 0 && (
          <div style={{ margin: '1rem' }}>
            <ReadOnlyAlert />
          </div>
        )}
        {!isLoading && !charges.length && (
          <div
            style={{
              textAlign: 'center',
              marginBottom: '1rem',
              padding: '2rem'
            }}
          >
            <CreateNewFolderIcon
              htmlColor="#6b7280"
              style={{ width: '36px', height: '36px' }}
            />
            <div style={{ fontWeight: 600 }}>No charges</div>
            <div style={{ color: '#6b7280' }}>
              {isFirmAdmin
                ? 'Get started by adding a new Platform/Product.'
                : 'Contact your firm administrator to add new charges.'}
            </div>
            <div
              style={{
                padding: '1rem 0rem 0rem 1rem'
              }}
            >
              <Button
                onClick={() => {
                  isFirmAdmin ? addCharge() : history.push(Routes.HOMEPAGE);
                }}
              >
                {isFirmAdmin
                  ? 'Add New Platform/Product'
                  : 'Go back to Dashboard'}
              </Button>
            </div>
          </div>
        )}
        {isLoading ? (
          <LoaderSpinner isLoading={isLoading} />
        ) : (
          <>
            {charges.length > 0 && isFirmAdmin && (
              <div
                style={{
                  padding: '1rem 0rem 0rem 1rem'
                }}
              >
                <Button
                  onClick={() => {
                    addCharge();
                  }}
                >
                  Add New Platform/Product
                </Button>
              </div>
            )}
            {charges
              .filter(chargesGroup => chargesGroup.length > 0)
              .map((chargesGroup: any, i: number) => {
                return (
                  <PlatformProviderSet
                    key={`pps-${i}`}
                    chargesGroup={chargesGroup}
                    chargeTypes={chargeTypes}
                    providerTypes={providerTypes}
                    platformTypes={platformTypes}
                    chargeValueTypes={chargeValueTypes}
                    policyTypes={policyTypes}
                    applicationTypes={applicationTypes}
                    i={i}
                    addChargeSet={addChargeSet}
                    editCharge={editCharge}
                    deleteChargeItem={deleteChargeItem}
                  />
                );
              })}
          </>
        )}
      </div>
      <Modal isOpen={isModalOpen} closeModalFunc={() => setIsModalOpen(false)}>
        <BoxWrapper
          title={
            !isFirmAdmin
              ? 'View charge'
              : chargeData && chargeData.id
                ? 'Edit charge'
                : 'New charge'
          }
          closeModal={() => setIsModalOpen(false)}
        >
          <div style={{ maxHeight: '74vh', overflow: 'auto', padding: '1rem' }}>
            <DropdownInput
              options={platformTypes}
              label={'Platform'}
              onChange={(e: any) => setSelectedPlatformType(e)}
              objectKey={'name'}
              style={{
                marginBottom: '1rem'
              }}
              search
              disabled={!isFirmAdmin}
              value={
                getPlatformType(chargeData.policy_platform)
                  ? getPlatformType(chargeData.policy_platform).name
                  : ''
              }
            />
            <DropdownInput
              options={providerTypes}
              label={'Provider'}
              onChange={(e: any) => setSelectedProviderType(e)}
              objectKey={'name'}
              search
              disabled={!isFirmAdmin}
              value={
                getProviderTypes(chargeData.policy_provider)
                  ? getProviderTypes(chargeData.policy_provider).name
                  : ''
              }
            />
            <ChargeSet
              chargeData={chargeData}
              updateChargeData={updateChargeData}
              updateCharge={updateCharge}
              selectedPlatformType={selectedPlatformType}
              selectedProviderType={selectedProviderType}
              applicationTypes={applicationTypes}
              isFirmAdmin={isFirmAdmin}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '1rem'
            }}
          >
            <Button color="primary" onClick={() => setIsModalOpen(false)}>
              Cancel
            </Button>
            {isFirmAdmin && (
              <Button
                onClick={() =>
                  document
                    .getElementById('platformProviderChargesSubmit')
                    ?.click()
                }
              >
                Save
              </Button>
            )}
          </div>
        </BoxWrapper>
      </Modal>
    </>
  );
};

export default connect((state: any) => ({
  isFirmAdmin: selectors.advisorSelectors.isFirmAdmin(state)
}))(ProviderPlatformChargesComponent);
